module.exports = __webpack_public_path__ + "img/main_logo.a1651367.png";